import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useStyles } from './FaceSwap.styles';
import { useDropzone } from 'react-dropzone';
import _ from 'lodash';

import Grid from '@material-ui/core/Grid';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import DeleteIcon from '@material-ui/icons/Delete';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import Slider from '@mui/material/Slider';
import Modal from '@mui/material/Modal';
import Dialog from '@material-ui/core/Dialog';
import Box from '@material-ui/core/Box';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

import FacesArrow from '../../../src/img/faceswap-arrow.svg';
import FacesPlus from '../../../src/img/faceswap-plus.svg';
import Settings from '../../../src/img/faceswap-settings.svg';
import Upload from '../../../src/img/faceswap-upload.svg';
import Download from '../../../src/img/faceswap-download.svg';
import WaterMarkImg from '../../../src/img/combined-logo-white.png';
import FileUploadImg from '../../../src/img/faceswap-fileUpload.svg';

import {
  uploadYoutubeVideoFile,
  detectFacesInImage,
  getYoutubeInfo,
  uploadFaceSwap,
  fetchSubscriptionInfo,
  getPreviewImage,
  getFaceSwapStatus,
  fetchRenderedVideoUrl,
  checkFaceSwapCompletion,
  detectFacesInVideo,
  uploadExternalSource,
} from '../../services/page.services';
import { userActions } from '../../actions/user.actions.js';
import { checkValidLoginStatus } from '../../utils/user.utils';
import { showMessageV2 } from '../../utils/page.utils';
import { formatTime } from '../../utils/page.utils';
import { getAudioDuration } from '../../utils/page.utils.js';

import FaceSwapSettings from '../layout/FaceSwapSettings.js';
import VideoLabelModal from '../layout/VideoLabelModal.js';
import HtmlTooltip from '../HtmlTooltip.js';
import tooltipImg from '../../img/tooltip.png';
import FaceSwapTrimmingSlider from '../layout/FaceSwapTrimmingSlider.js';
import { external } from 'jszip';

function FaceSwapPage() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector(state => state.user);
  const userId = user?.id;
  const faceBoxRefs = useRef({});
  const videoRef = useRef(null);
  const videoContainerRef = useRef(null);
  const [fps, setFPS] = useState(30);
  const finalVideoRef = useRef(null);

  // State Initialization
  const [content, setContent] = useState({});

  const [uploadState, setUploadState] = useState({
    uploadedVideoUrl: null,
    isVideoSplited: false,
    videoLoading: false,
    isVideoTagLoading: true,
    finalVideoUrl: null,
    finalVideoLoading: false,
    distance: 0.73,
    leastFrame: 4,
    objectKey: null,
    externalUpload: false,
    extension: 'mp4',
  });

  const [videoState, setVideoState] = useState({
    currentFrame: 0,
    currentTime: 0,
    duration: 0,
  });
  const [stepOneDuration, setStepOneDuration] = useState(0);
  const [stepTwoDuration, setStepTwoDuration] = useState(0);

  const [sliderState, setSliderState] = useState({
    sliderValue: 0,
    range: [0, 0, 100],
  });

  const [stepOneTimeRange, setStepOneTimeRange] = useState({
    startTime: 0,
    endTime: 0,
  });

  const [sliderStateStepTwo, setSliderStateStepTwo] = useState({
    sliderValue: 0,
    range: [0, 0, 100],
  });

  const [finalSliderState, setFinalSliderState] = useState({
    range: 0,
  });
  const [isFinalVideoPlaying, setIsFinalVideoPlaying] = useState(false);

  const [settingsState, setSettingsState] = useState({
    isSharpnessOn: false,
    isWatermarkOn: true,
    blendRatio: 70,
  });

  const [originalFaceData, setOriginalFaceData] = useState([]);
  const [faceData, setFaceData] = useState([]);
  // {
  //   index: Number, // Index of the face
  //   data: Object, // { face: [Object], frame: number } (preview endpoint request data: originalFaceData)
  //   croppedFace: String, // Data URL of the face image extracted from the video
  //   selected: Boolean, // Whether the face is selected
  //   selectedNewFace: String, // Selected new face; if not selected, null
  //   newImage: File,  // Original image file of the selected new face (preview endpoint request data)
  //   newFaceData: Object, // Index data of the selected new face (preview endpoint request data)
  //   bboxLength: Number,  // For testing
  // }

  const [modalImageIndex, setModalImageIndex] = useState(null);
  const [croppedFacesInImage, setCroppedFacesInImage] = useState([]);
  const [croppedFacesData, setCroppedFacesData] = useState([]);
  const [previewImageURL, setPreviewImageURL] = useState(null);
  const [exportName, setExportName] = useState('');
  const [rendering, setRendering] = useState(false);

  const [videoReady, setVideoReady] = useState(false);
  const [isFaceSelectionModalOpen, setIsFaceSelectionModalOpen] = useState(false);
  const [isProcessingFaces, setIsProcessingFaces] = useState(false);
  const [isImageProcessing, setIsImageProcessing] = useState(false);
  const [isFaceDetected, setIsFaceDetected] = useState(false);

  const [requiredCoins, setRequiredCoins] = useState(0);
  const tierToShowOutputFormat = ['PREMIUM', 'PRO', 'PREMIUM_YEARLY', 'PRO_YEARLY', 'ADMIN', 'CUSTOM'];
  const [showUpgrade, setShowUpgrade] = useState(false);
  const [showCoinUpgrade, setShowCoinUpgrade] = useState(false);
  const [showRenderDelay, setShowRenderDelay] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [isSettingsModalOpen, setIsSettingsModalOpen] = useState(false);
  const [isReadyToShowPreview, setIsReadyToShowPreview] = useState(false);
  const [faceSwapRemainingcount, setFaceSwapRemainingcount] = useState(0);
  const [faceSwapInProgress, setFaceSwapInProgress] = useState(false);
  const [loadingText, setLoadingText] = useState([]);
  const [videoExportModalOpen, setVideoExportModalOpen] = useState(false);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [showReloadDialog, setShowReloadDialog] = useState(false);
  const [showPoorCoinDialog, setShowPoorCoinDialog] = useState(false);
  const [showSharpnessDialog, setShowSharpnessDialog] = useState(false);

  const classes = useStyles();

  useEffect(() => {
    if (userId) (async () => initPage())();
  }, [userId]);

  // Effect to manage subscription-based UI disabling
  useEffect(() => {
    if (!tierToShowOutputFormat.includes(user.subscription?.type)) {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  }, [tierToShowOutputFormat, user.subscription?.type]);

  // price logic
  useEffect(() => {
    if (faceData.filter(face => face.selected).length !== 0) {
      const selectedDuration = Math.ceil(stepTwoDuration / 15);
      const coinsCalculated = selectedDuration * 15 * faceData.filter(face => face.selected).length;
      setRequiredCoins(coinsCalculated);
    } else if (stepTwoDuration > 0 && uploadState.isVideoSplited) {
      const selectedDuration = Math.ceil(stepTwoDuration / 15);
      const coinsCalculated = selectedDuration * 15;
      setRequiredCoins(coinsCalculated);
    } else {
      const selectedDuration = Math.ceil(stepOneDuration / 15);
      const coinsCalculated = selectedDuration * 15;
      setRequiredCoins(coinsCalculated);
    }
  }, [stepOneDuration, stepTwoDuration, faceData.filter(face => face.selected)]);

  useEffect(() => {
    if (requiredCoins > faceSwapRemainingcount) {
      setShowPoorCoinDialog(true);
    }
    if (requiredCoins - faceSwapRemainingcount === 0) {
      setShowPoorCoinDialog(false);
    }
  }, [requiredCoins]);

  useEffect(() => {
    const hasNewFaceData = faceData.filter(face => face.newFaceData !== null);
    if (hasNewFaceData.length > 0) {
      //showPreview();
    }
  }, [faceData.filter(face => face.newFaceData !== null).join(',')]);

  useEffect(() => {
    if (rendering) {
      handleStart();
    }
  }, [rendering]);

  useEffect(() => {
    if (isReadyToShowPreview) {
      showPreview();
    }
  }, [isReadyToShowPreview]);

  // After faceData, videoReady are ready, detect faces
  useEffect(() => {
    if (originalFaceData.length > 0 && isFaceDetected) {
      processFaces();
    }
  }, [originalFaceData, isFaceDetected]);

  // Monitor video playback progress
  useEffect(() => {
    let progressInterval = null;
    if (uploadState.uploadedVideoUrl) {
      progressInterval = setInterval(() => {
        const videoElement = videoRef.current;
        if (videoElement && videoElement.duration > 0) {
          const newProgress = (videoElement.currentTime / videoElement.duration) * 100;
          setSliderState(prev => ({
            ...prev,
            sliderValue: newProgress,
          }));
          setVideoState(prev => ({
            ...prev,
            currentFrame: Math.floor(videoElement.currentTime * fps),
            currentTime: videoElement.currentTime,
            duration: videoElement.duration,
          }));
        }
      }, 500);
    }
    return () => {
      if (progressInterval) clearInterval(progressInterval);
    };
  }, [uploadState.uploadedVideoUrl]);

  useEffect(() => {
    let finalInterval = null;
    if (uploadState.finalVideoUrl && finalVideoRef.current) {
      const finalVideoElement = finalVideoRef.current;
      finalInterval = setInterval(() => {
        if (finalVideoElement.duration > 0 && !finalVideoElement.paused) {
          const percentage = (finalVideoElement.currentTime / finalVideoElement.duration) * 100;
          setFinalSliderState({ range: percentage });
        }
      }, 300);
    }
    return () => {
      if (finalInterval) clearInterval(finalInterval);
    };
  }, [uploadState.finalVideoUrl]);

  useEffect(() => {
    return () => {
      if (previewImageURL) {
        URL.revokeObjectURL(previewImageURL);
      }
    };
  }, [previewImageURL]);

  useEffect(() => {
    if (uploadState.isVideoSplited) {
      handleFaceDetectInVideo(uploadState.leastFrame);
    }
  }, [uploadState.isVideoSplited, uploadState.leastFrame]);

  const initPage = async () => {
    try {
      //if (!isAdmin && !isCustom) {
      // TODO
      // to Haesol: please develop a function checks if the face swap is in progress or not
      await checkFaceSwapInProgress();
      //}
      await checkRemainingCount();
    } catch (e) {
      console.log(e);
      showMessageV2(dispatch, t('modal.pageLoadFail'), { reloadOnClose: true });
    }
  };

  const checkFaceSwapInProgress = async () => {
    const faceSwaps = await checkFaceSwapCompletion();
    const inProgress = _.some(faceSwaps, { status: 'PENDING' });
    setFaceSwapInProgress(inProgress);
  };

  const checkRemainingCount = async () => {
    let subscriptionInfo = await fetchSubscriptionInfo();
    dispatch(userActions.updateSubscription(subscriptionInfo));
    setFaceSwapRemainingcount(
      (subscriptionInfo?.type === 'FREE'
        ? subscriptionInfo?.freeFaceSwapRemaining + subscriptionInfo?.genCreditsRemaining
        : subscriptionInfo?.genCreditsRemaining) || 0
    );
    return subscriptionInfo;
  };

  // update the size of videoContainer for Watermark
  useEffect(() => {
    const videoElement = videoRef.current;
    const containerElement = videoContainerRef.current;
    if (videoElement && containerElement) {
      const updateContainerSize = () => {
        const videoRect = videoElement.getBoundingClientRect();
        containerElement.style.width = `${videoRect.width}px`;
        containerElement.style.height = `${videoRect.height}px`;
      };
      updateContainerSize();
      const resizeObserver = new ResizeObserver(entries => {
        for (let entry of entries) {
          if (entry.target === videoElement) {
            updateContainerSize();
          }
        }
      });
      resizeObserver.observe(videoElement);
      return () => {
        resizeObserver.unobserve(videoElement);
      };
    }
  }, []);

  useEffect(() => {
    if (isDisabled && settingsState.isSharpnessOn) {
      setShowSharpnessDialog(true);
    }
  }, [settingsState.isSharpnessOn]);

  // Handle video upload
  const handleYoutubeUpload = async () => {
    if (faceSwapInProgress) {
      showMessageV2(dispatch, t('faceSwapTab.modal.inProgress'), { reloadOnClose: true });
      return;
    }
    setUploadState(prev => ({ ...prev, videoLoading: true }));
    try {
      const { duration, valid, name } = await getYoutubeInfo(content.youtubeLink);
      if (!valid) {
        setContent({ ...content, youtubeLink: '', name: null });
        showMessageV2(dispatch, t('addSourceModal.youtube.invalidYoutubeLink'), { reloadOnClose: true });
      } else if (duration > 900) {
        setContent({ ...content, youtubeLink: '', name: null });
        showMessageV2(dispatch, t('faceSwapTab.error.youtubeLinkTooLong'), { reloadOnClose: true });
      } else {
        // setUploadState(prev => ({ ...prev, videoLoading: false }));
        setVideoState({ ...videoState, duration: duration });
        setContent({
          ...content,
          name,
        });
        setExportName(name);
        // const distanceNum = uploadState.distance;
        // const leastFrameNum = uploadState.leastFrame;
        const response = await uploadYoutubeVideoFile(content.youtubeLink, name);
        if (response) {
          setUploadState(prev => ({ ...prev, uploadedVideoUrl: response.signedUrl, objectKey: response.objectKey }));
          setStepOneDuration(Number(duration));
          // setOriginalFaceData(response.faceData.faces);
          // setFPS(response.faceData.fps);
        } else {
          showMessageV2(dispatch, t('inferenceTab.modal.uploadFail'), { reloadOnClose: true });
        }
      }
    } catch (error) {
      showMessageV2(dispatch, t('inferenceTab.submit.tryAgain'), { reloadOnClose: true });
      //console.log('YouTube video upload error:', error);
    }
  };

  // Detect faces in video
  const handleFaceDetectInVideo = async updatedLeastFrame => {
    setIsProcessingFaces(true);
    //console.log('updatedLeastFrame: ', updatedLeastFrame); // leastFrame 테스트
    try {
      const distanceNum = uploadState.distance;
      const leastFrameNum = updatedLeastFrame;
      const { startTime, endTime } = stepOneTimeRange;
      const videoUrl = content.youtubeLink || content.fileUrl;
      const response = await detectFacesInVideo(
        videoUrl,
        content.name,
        distanceNum,
        leastFrameNum,
        startTime,
        endTime,
        uploadState.externalUpload,
        uploadState.extension
      );
      //console.log('response:', response);
      if (response) {
        if (response.faceData.faces.length === 0) {
          setIsProcessingFaces(false);
        }
        setOriginalFaceData(response.faceData.faces);
        setFPS(response.faceData.fps);
      } else {
        showMessageV2(dispatch, t('inferenceTab.modal.uploadFail'), { reloadOnClose: true });
      }
      //setUploadState(prev => ({ ...prev, isVideoSplited: true }));
      setIsFaceDetected(true);
    } catch (error) {
      showMessageV2(dispatch, t('inferenceTab.submit.tryAgain'), { reloadOnClose: true });
      //console.log('YouTube video upload error:', error);
    } finally {
      setUploadState(prev => ({ ...prev, videoLoading: false }));
    }
  };

  // Handle video deletion
  const handleDeleteVideo = () => {
    setContent({});
    setUploadState({
      uploadedVideoUrl: null,
      isVideoSplited: false,
      videoLoading: false,
      isVideoTagLoading: true,
      finalVideoUrl: null,
      distance: 0.73,
      leastFrame: 4,
      objectKey: null,
      externalUpload: false,
      extension: 'mp4',
    });
    setVideoState({
      currentFrame: 0,
      currentTime: 0,
      duration: 0,
    });
    setStepOneTimeRange({
      startTime: 0,
      endTime: 0,
    });
    setVideoState({
      currentFrame: 0,
      currentTime: 0,
      duration: 0,
    });
    setStepOneTimeRange({
      startTime: 0,
      endTime: 0,
      externalUpload: false,
    });
    setVideoState({
      currentFrame: 0,
      currentTime: 0,
      duration: 0,
    });
    setStepOneTimeRange({
      startTime: 0,
      endTime: 0,
    });
    setVideoState({
      currentFrame: 0,
      currentTime: 0,
      duration: 0,
    });
    setStepOneTimeRange({
      startTime: 0,
      endTime: 0,
    });
    setVideoState({
      currentFrame: 0,
      currentTime: 0,
      duration: 0,
    });
    setStepOneTimeRange({
      startTime: 0,
      endTime: 0,
    });
    setSliderState({
      sliderValue: 0,
      range: [0, 0, 100],
    });
    setSliderStateStepTwo({
      sliderValue: 0,
      range: [0, 0, 100],
    });
    setFinalSliderState({
      range: 0,
    });
    setSliderStateStepTwo({
      sliderValue: 0,
      range: [0, 0, 100],
    });
    setFinalSliderState({
      range: 0,
    });
    setSettingsState({
      isSharpnessOn: false,
      isWatermarkOn: true,
      blendRatio: 70,
    });
    setVideoReady(false);
    setStepOneDuration(0);
    setStepTwoDuration(0);
    setStepOneDuration(0);
    setStepTwoDuration(0);
    setRequiredCoins(0);
    setPreviewImageURL(null);
    setFaceData([]);
    setOriginalFaceData([]);
    setIsProcessingFaces(false);
    setIsFaceDetected(false);
    setFPS(30);
  };

  // Handle blend ratio change
  // const handleBlendRatioChange = (event, newValue) => {
  //   if (newValue >= 0 && newValue <= 100) {
  //     setSettingsState(prev => ({ ...prev, blendRatio: newValue }));
  //   }
  // };

  // Handle range slider change
  const handleRangeChange = (event, newValues, activeThumb) => {
    if (faceSwapRemainingcount < 15) {
      setShowCoinUpgrade(true);
      return;
    }
    setPreviewImageURL(null);

    const newDuration = Math.floor(((newValues[2] - newValues[0]) / 100.0) * videoState.duration);
    setStepOneDuration(newDuration);
    setSliderState(prev => ({ ...prev, range: newValues }));
    updateVideoCurrentTime(activeThumb, newValues);
  };

  const handleSliderChangeCommitted = (event, newValues) => {
    // console.log('최종 값:', newValues);
  };

  const handleRangeChangeStepTwo = (event, newValues, activeThumb) => {
    setPreviewImageURL(null);

    const newDurationTwo = Math.floor(((newValues[2] - newValues[0]) / 100.0) * stepOneDuration);
    setStepTwoDuration(newDurationTwo);
    setSliderStateStepTwo(prev => ({ ...prev, range: newValues }));
    updateVideoCurrentTimeStepTwo(activeThumb, newValues);
  };

  // Update video current time based on slider
  const updateVideoCurrentTime = (activeThumb, newValues) => {
    if (videoRef.current) {
      const videoElement = videoRef.current;
      if (videoElement && videoElement.duration && videoElement.duration > 0) {
        const duration = videoElement.duration;
        let newTime;

        switch (activeThumb) {
          case 0:
            newTime = (newValues[0] / 100) * duration;
            break;
          case 1:
            newTime = (newValues[1] / 100) * duration;
            break;
          case 2:
            newTime = (newValues[2] / 100) * duration;
            break;
          default:
            newTime = 0;
        }
        videoElement.currentTime = newTime;
        videoElement.pause();

        videoElement.ontimeupdate = () => {
          if (videoElement.currentTime >= (newValues[2] / 100) * duration) {
            videoElement.pause();
          }
        };
      }
    }
  };

  const updateVideoCurrentTimeStepTwo = (activeThumb, newValues) => {
    const videoElement = videoRef.current;
    if (!videoElement) return;
    const { startTime, endTime } = stepOneTimeRange;
    const totalRange = endTime - startTime;

    let chosenPercent = 0;
    if (activeThumb === 0) chosenPercent = newValues[0];
    if (activeThumb === 1) chosenPercent = newValues[1];
    if (activeThumb === 2) chosenPercent = newValues[2];

    const newTime = startTime + (chosenPercent / 100) * totalRange;

    videoElement.currentTime = newTime;
  };

  // Handle video time update
  const handleTimeUpdate = () => {
    const videoElement = videoRef.current;
    if (videoElement) {
      setVideoState(prev => ({
        ...prev,
        currentTime: videoElement.currentTime,
        duration: videoElement.duration,
        currentFrame: Math.floor(videoElement.currentTime * fps),
      }));
      setSliderState(prev => ({
        ...prev,
        sliderValue: (videoElement.currentTime / videoElement.duration) * 100,
      }));
    }
  };

  const handleTimeUpdateStepTwo = () => {
    const videoElement = videoRef.current;
    if (!videoElement) return;
    const currentTime = videoElement.currentTime;
    const { startTime, endTime } = stepOneTimeRange;
    if (currentTime < startTime) {
      videoElement.currentTime = startTime;
    }
    if (currentTime > endTime) {
      videoElement.currentTime = endTime;
      videoElement.pause();
    }
    const totalRange = endTime - startTime;
    const playedPercent = Math.ceil(((currentTime - startTime) / totalRange) * 100);

    setSliderStateStepTwo(prev => ({
      ...prev,
      sliderValue: playedPercent,
    }));
  };

  // Handle video metadata loaded
  const handleLoadedMetadata = () => {
    const videoElement = videoRef.current;
    if (videoElement) {
      setVideoState(prev => ({
        ...prev,
        duration: videoElement.duration,
      }));
    }
    setVideoReady(true);
  };

  const processFaces = async () => {
    try {
      const videoElement = videoRef.current;

      const processedFaceData = [];
      for (let i = 0; i < originalFaceData.length; i++) {
        const faceObj = originalFaceData[i];
        const frameNumber = faceObj.frame;
        const time = frameNumber / fps;
        await seekVideoToTime(videoElement, time, fps, i);
        const imageDataUrl = await captureAndCropFace(videoElement, faceObj.face.bbox);
        processedFaceData.push({
          index: i,
          data: faceObj,
          croppedFace: imageDataUrl,
          selected: false,
          selectedNewFace: null,
          newImage: null,
          newFaceData: null,
          bboxLength: faceObj.appearance_count,
          appearance_count: faceObj.appearance_count,
        });
      }
      videoElement.currentTime = stepOneTimeRange.startTime;
      setFaceData(processedFaceData);
      await seekVideoToTime(videoElement, 21.366666666666667, fps, 0);
    } catch (error) {
      showMessageV2(dispatch, t('faceSwapTab.error.facesInImage'), { reloadOnClose: true });
    } finally {
      setIsProcessingFaces(false);
    }
  };

  const captureOriginalImage = videoElement => {
    return new Promise((resolve, reject) => {
      const canvas = document.createElement('canvas');
      canvas.width = videoElement.videoWidth;
      canvas.height = videoElement.videoHeight;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);

      canvas.toBlob(blob => {
        if (blob) {
          const file = new File([blob], 'captured_frame.png', { type: 'image/png' });
          resolve(file);
        } else {
          reject(new Error('Canvas is empty'));
        }
      }, 'image/png');
    });
  };

  const showPreview = async () => {
    try {
      const videoElement = videoRef.current;
      const imageBuffer = await captureOriginalImage(videoElement);
      const oldFacesDataArray = faceData.map(fd => fd.data.face.embedding);
      const newFacesDataArray = faceData.map(fd => (fd.newFaceData ? fd.newFaceData.embedding : null));
      const distanceNum = uploadState.distance;

      const selectedIndices = faceData.map((fd, idx) => (fd.selected ? idx : null)).filter(idx => idx !== null);

      const filteredOldFacesData = selectedIndices.map(idx => ({
        embedding: oldFacesDataArray[idx],
      }));

      const filteredNewFacesData = selectedIndices.map(idx => ({
        embedding: newFacesDataArray[idx],
      }));
      setPreviewImageURL(null);
      if (filteredOldFacesData.length === 0 || filteredNewFacesData.length === 0) {
        showMessageV2(dispatch, t('faceSwapTab.error.noFacesSelected'));
        return;
      }

      setPreviewLoading(true);
      const previewResponse = await getPreviewImage(
        distanceNum,
        imageBuffer,
        filteredOldFacesData,
        filteredNewFacesData,
        settingsState.isSharpnessOn,
        settingsState.blendRatio
      );

      if (previewResponse) {
        const imageUrl = URL.createObjectURL(new Blob([previewResponse], { type: 'image/jpeg' }));
        setPreviewImageURL(imageUrl);
      } else {
        showMessageV2(dispatch, t('faceSwapTab.error.invalidPreviewResponse'), { reloadOnClose: true });
      }
    } catch (error) {
      showMessageV2(dispatch, t('faceSwapTab.error.showPreview'), { reloadOnClose: true });
    } finally {
      setPreviewLoading(false);
      setIsReadyToShowPreview(false);
    }
  };

  const seekVideoToTime = (videoElement, time, fps, i) => {
    return new Promise((resolve, reject) => {
      const onSeeked = () => {
        videoElement.removeEventListener('seeked', onSeeked);
        setTimeout(() => resolve(), 500);
      };
      videoElement.addEventListener('seeked', onSeeked);
      videoElement.currentTime = time;
    });
  };

  const captureAndCropFace = (videoElement, bbox) => {
    return new Promise((resolve, reject) => {
      const canvas = document.createElement('canvas');
      const [x1, y1, x2, y2] = bbox;
      const width = x2 - x1;
      const height = y2 - y1;
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');

      ctx.drawImage(videoElement, x1, y1, width, height, 0, 0, width, height);
      const dataUrl = canvas.toDataURL('image/png');
      resolve(dataUrl);
    });
  };

  // Handle face deletion
  const handleDeleteSelectedFace = index => {
    setFaceData(prevFaceData =>
      prevFaceData.map(face =>
        face.index === index
          ? { ...face, selected: false, selectedNewFace: null, newImage: null, newFaceData: null }
          : face
      )
    );
  };

  const handleWatermarkToggle = () => {
    setSettingsState(prev => ({ ...prev, isWatermarkOn: !prev.isWatermarkOn }));
    if (isDisabled) {
      setSettingsState(prev => ({ ...prev, isWatermarkOn: true }));
      setShowUpgrade(true);
    }
  };

  // Handle image change
  const handleImageChange = async (event, index) => {
    const file = event.target.files[0];
    if (file) {
      const validTypes = ['image/jpeg', 'image/png', 'image/gif'];
      const maxSize = 10 * 1024 * 1024; // 10MB

      if (!validTypes.includes(file.type)) {
        showMessageV2(dispatch, t('faceSwapTab.error.invalidFileType'), { reloadOnClose: true });
        return;
      }

      if (file.size > maxSize) {
        showMessageV2(dispatch, t('faceSwapTab.error.fileTooLarge'), { reloadOnClose: true });
        return;
      }

      try {
        setIsImageProcessing(true);

        const data = await detectFacesInImage(file);

        if (data.faces && data.faces.length > 0) {
          const reader = new FileReader();
          reader.onloadend = () => {
            const imageDataUrl = reader.result;
            const img = new Image();
            img.src = imageDataUrl;

            img.onload = () => {
              const canvas = document.createElement('canvas');
              const ctx = canvas.getContext('2d');

              const croppedImages = data.faces.map(face => {
                const [x1, y1, x2, y2] = face.bbox;
                const width = x2 - x1;
                const height = y2 - y1;

                canvas.width = width;
                canvas.height = height;
                ctx.clearRect(0, 0, width, height);
                ctx.drawImage(img, x1, y1, width, height, 0, 0, width, height);
                return canvas.toDataURL('image/png');
              });

              setCroppedFacesInImage(croppedImages);
              setCroppedFacesData(data.faces);
              setIsImageProcessing(false);

              setFaceData(prevData => {
                const updatedData = [...prevData];
                updatedData[index] = { ...prevData[index], newImage: file };
                return updatedData;
              });
            };
          };
          reader.readAsDataURL(file);
        } else {
          showMessageV2(dispatch, t('faceSwapTab.error.noFacesDetected'), { reloadOnClose: true });
          setIsImageProcessing(false);
        }
      } catch (error) {
        showMessageV2(dispatch, t('faceSwapTab.error.faceDetectApiError'), { reloadOnClose: true });
        setIsImageProcessing(false);
      }
    }
  };

  // Handle settings modal open
  const handleSettingsButtonClick = () => {
    setIsSettingsModalOpen(true);
  };

  const handleOpenVideoLabelModal = () => {
    if (faceSwapInProgress) {
      showMessageV2(dispatch, t('faceSwapTab.modal.inProgress'), { reloadOnClose: true });
    } else if (requiredCoins > faceSwapRemainingcount) {
      setShowCoinUpgrade(true);
    } else if (faceData.filter(face => face.selected).length === 0) {
      showMessageV2(dispatch, t('faceSwapTab.error.noFacesSelected'), { reloadOnClose: true });
      return;
    } else {
      setVideoExportModalOpen(true);
    }
  };

  // Polling for check face swap status
  const pollFaceSwapStatus = faceSwapId => {
    const interval = setInterval(async () => {
      try {
        const response = await getFaceSwapStatus(faceSwapId); //await axiosInstance.get(`/faceSwap/status/${faceSwapId}`);
        const status = response.status;
        if (status === 'COMPLETE') {
          clearInterval(interval);
          clearTimeout(timeoutId);
          setLoadingText([t('faceSwapTab.loading.5')]);
          const videoResponse = await fetchRenderedVideoUrl(faceSwapId);
          if (videoResponse && videoResponse.url) {
            setUploadState(prev => ({ ...prev, finalVideoUrl: videoResponse.url }));
          }
          setLoadingText([]);
        } else if (status === 'FAILED') {
          clearInterval(interval);
          clearTimeout(timeoutId);
          setLoadingText([]);
          showMessageV2(dispatch, t('faceSwapTab.error.renderingFailed'), { reloadOnClose: true });
        }
        // if status == 'PENDING', keep polling
      } catch (error) {
        console.error('Error polling face swap status:', error);
      }
    }, 5000);

    const timeoutId = setTimeout(
      () => {
        clearInterval(interval);
        setShowRenderDelay(true);
      },
      10 * 60 * 1000
    );
  };

  // Handle start face swap
  const handleStart = async () => {
    if (isDisabled) {
      setSettingsState({ ...settingsState, isSharpnessOn: false });
    }
    setUploadState({ ...uploadState, finalVideoLoading: true });
    setLoadingText([
      t('faceSwapTab.loading.finalVideoGenerating.0'),
      t('faceSwapTab.loading.finalVideoGenerating.1'),
      t('faceSwapTab.loading.finalVideoGenerating.2'),
      t('faceSwapTab.loading.finalVideoGenerating.3'),
    ]);

    const oldFacesDataArray = faceData.map(fd => fd.data.face.embedding);
    const newFacesDataArray = faceData.map(fd => (fd.newFaceData ? fd.newFaceData.embedding : null));
    const distanceNum = uploadState.distance;

    const selectedIndices = faceData.map((fd, idx) => (fd.selected ? idx : null)).filter(idx => idx !== null);

    const filteredOldFacesData = selectedIndices.map(idx => ({
      embedding: oldFacesDataArray[idx],
    }));

    const filteredNewFacesData = selectedIndices.map(idx => ({
      embedding: newFacesDataArray[idx],
    }));

    if (filteredOldFacesData.length === 0 || filteredNewFacesData.length === 0) {
      showMessageV2(dispatch, t('faceSwapTab.error.noFacesSelected'));
      return;
    }

    try {
      const [subStart, , subEnd] = sliderStateStepTwo.range;
      const startTime = stepOneTimeRange.startTime + (subStart / 100) * stepOneDuration;
      const endTime = stepOneTimeRange.startTime + (subEnd / 100) * stepOneDuration;

      const label = exportName;
      const tier = user.subscription.type;
      // const startTime = Math.floor((sliderState.range[0] / 100) * videoState.duration);
      // const endTime = Math.ceil((sliderState.range[2] / 100) * videoState.duration);
      const faceCount = faceData.filter(face => face.selected).length;
      const watermark = settingsState.isWatermarkOn;
      const faceSwapSharpness = settingsState.isSharpnessOn;
      const faceSwapBlendRatio = settingsState.blendRatio;
      const anonymous = true;
      const userName = user.name;
      const usedCoins = Math.max(1, Math.ceil(stepTwoDuration / 15) * 15 * faceCount);
      const videoUrl = content.youtubeLink || content.fileUrl;

      const response = await uploadFaceSwap(
        userId,
        label,
        tier,
        Math.floor(startTime),
        Math.ceil(endTime),
        faceCount,
        watermark,
        faceSwapSharpness,
        faceSwapBlendRatio,
        anonymous,
        userName,
        usedCoins,
        videoUrl,
        distanceNum,
        filteredOldFacesData,
        filteredNewFacesData,
        settingsState.isSharpnessOn,
        settingsState.blendRatio,
        uploadState.externalUpload,
        uploadState.objectKey,
        uploadState.extension
      );

      if (response && response.id) {
        pollFaceSwapStatus(response.id);
      } else {
        showMessageV2(dispatch, t('faceSwapTab.error.uploadFailed'));
        setLoadingText([]);
      }
    } catch (e) {
      setUploadState({ ...uploadState, finalVideoLoading: false });
      setLoadingText([]);
      setShowReloadDialog(true);
      return;
    }
  };

  // Handle distance change
  // const handleDistanceChange = (event, newValue) => {
  //   if (newValue >= 0 && newValue <= 1) {
  //     setUploadState(prev => ({ ...prev, distance: newValue }));
  //   }
  // };

  // Final video Play or Pause
  const handleFinalPlay = () => {
    const video = finalVideoRef.current;
    if (!video) return;

    video.play();
    setIsFinalVideoPlaying(true);
  };

  // Final video Stop
  const handleFinalPause = () => {
    const video = finalVideoRef.current;
    if (!video) return;

    video.pause();
    setIsFinalVideoPlaying(false);
  };

  // Final video Sider
  const handleFinalSliderChange = (e, newValue) => {
    const video = finalVideoRef.current;
    setFinalSliderState({ range: newValue });
    if (video && video.duration) {
      const seekTime = (newValue / 100) * video.duration;
      video.currentTime = seekTime;
    }
  };

  const handleDownload = async url => {
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const tempLink = document.createElement('a');
      tempLink.href = blobUrl;

      let fileName = exportName ? exportName : 'download';
      if (!fileName.toLowerCase().endsWith('.mp4')) {
        fileName += '.mp4';
      }

      tempLink.download = fileName;

      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);

      window.URL.revokeObjectURL(blobUrl);
    } catch (e) {
      showMessageV2(dispatch, t('faceSwapTab.error.downloadFailed'));
    }
  };

  const handleApply = async newSettings => {
    setSettingsState(prevSettings => ({
      ...prevSettings,
      ...newSettings,
    }));
    setIsSettingsModalOpen(false);
    setIsReadyToShowPreview(true);
  };

  const handleReloadDialog = () => {
    setShowReloadDialog(false);
    window.location.reload();
  };

  const handlePrevButton = () => {
    setUploadState({ ...uploadState, isVideoSplited: false });
    setStepTwoDuration(0);
    setIsFaceDetected(false);
    setIsProcessingFaces(false);
    setPreviewLoading(false);
    setFaceData([]);
    setPreviewImageURL(null);
  };

  const handleNextButton = () => {
    if (stepOneDuration <= 15) {
      setUploadState(prev => ({ ...prev, leastFrame: 2 }));
    } else if (stepOneDuration > 15) {
      setUploadState(prev => ({ ...prev, leastFrame: 4 }));
    }
    const totalDuration = videoState.duration;
    const startTime = (sliderState.range[0] / 100) * totalDuration;
    const endTime = (sliderState.range[2] / 100) * totalDuration;
    setStepOneTimeRange({ startTime, endTime });
    setStepTwoDuration(stepOneDuration);
    setUploadState(prev => ({ ...prev, isVideoSplited: true }));
  };

  const onDropAccepted = async acceptedFiles => {
    if (faceSwapInProgress) {
      showMessageV2(dispatch, t('faceSwapTab.modal.inProgress'), { reloadOnClose: true });
      return;
    }
    setUploadState(prev => ({ ...prev, videoLoading: true }));

    if (checkValidLoginStatus(userId, dispatch) && acceptedFiles.length > 0) {
      try {
        const file = acceptedFiles[0];
        const fileName = file.name.replace(/\.[^/.]+$/, '');
        const extension = file.name.split('.').pop();
        const { url, nsfw } = await uploadExternalSource({ file, fileName, extension }, 'video');
        const duration = await getAudioDuration(url);
        if (duration > 900) {
          setContent({ ...content, name: null });
          handleDeleteVideo();
          showMessageV2(dispatch, t('faceSwapTab.error.youtubeLinkTooLong'), { reloadOnClose: true });
        } else if (nsfw) {
          setContent({ ...content, name: null });
          handleDeleteVideo();
          showMessageV2(dispatch, t('faceSwapTab.error.nsfwVideo'), { reloadOnClose: true });
        } else {
          setVideoState({ ...videoState, duration: duration });
          setContent({ ...content, file, name: fileName, fileUrl: url });
          setExportName(fileName);
          if (url) {
            setUploadState(prev => ({
              ...prev,
              uploadedVideoUrl: url,
              objectKey: fileName,
              externalUpload: true,
              extension: extension,
            }));
            setStepOneDuration(Number(duration));
            // setOriginalFaceData(response.faceData.faces);
            // setFPS(response.faceData.fps);
          } else {
            showMessageV2(dispatch, t('inferenceTab.modal.uploadFail'), { reloadOnClose: true });
          }
        }
      } catch (e) {
        showMessageV2(dispatch, t('inferenceTab.submit.tryAgain'));
        handleDeleteVideo();
        console.log('File upload error:', e);
      }
    }
  };
  const onDropRejected = async input => {
    if (checkValidLoginStatus(userId, dispatch)) {
      const message = (() => {
        switch (input[0].errors[0].code) {
          case 'file-invalid-type':
            return t('inferenceTab.modal.notSupportedFileType');
          case 'file-too-large':
            return t('inferenceTab.modal.exceedMaxSize');
        }
      })();
      if (message) showMessageV2(dispatch, message);
    }
  };
  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      'video/mpeg-4': ['.mp4', '.MP4'],
      'video/x-matroska': ['.mkv', '.MKV'],
      'video/mov': ['.mov', '.MOV'],
    },
    maxFiles: 1,
    onDropAccepted,
    onDropRejected,
    disabled: faceSwapInProgress || content.youtubeLink,
    maxSize: 78643200,
  });

  return (
    <>
      <VideoLabelModal
        open={videoExportModalOpen}
        onVideoExportModalClose={() => setVideoExportModalOpen(false)}
        exportName={exportName}
        setExportName={setExportName}
        rendering={rendering}
        setRendering={setRendering}
      />
      <div className={classes.rootPage}>
        <div className={classes.pageTitle}>{t('faceSwapTab.title')}</div>
        <div className={classes.separater} />
        <Grid container spacing={3}>
          <Grid item xs={12}>
            {uploadState.isVideoSplited ? (
              <>
                {rendering ? (
                  <>
                    <div className={classes.stepHeader}>{t('faceSwapTab.stepThree.title')}</div>
                    <div className={classes.stepSubHeader}>{t('faceSwapTab.stepThree.subTitles')}</div>
                  </>
                ) : (
                  <>
                    <div className={classes.stepHeader}>{t('faceSwapTab.stepTwo.title')}</div>
                    <div className={classes.stepSubHeader}>{t('faceSwapTab.stepTwo.subTitles')}</div>
                  </>
                )}
              </>
            ) : (
              <>
                <div className={classes.stepHeader}>{t('faceSwapTab.stepOne.title')}</div>
                <div className={classes.stepSubHeader}>{t('faceSwapTab.stepOne.subTitles')}</div>
              </>
            )}
            <div className={classes.recordButtonContainer}>
              {uploadState.isVideoSplited && (
                <>
                  {rendering ? (
                    <>
                      {uploadState.finalVideoUrl ? (
                        <Grid container className={classes.allContainer}>
                          <Grid item id="video-container" className={classes.previewContainer}>
                            <div className={classes.tag}>{t('faceSwapTab.stepThree.tags.sourceFile')}</div>
                            <Button
                              className={classes.youtubeInfoDeleteIconBox}
                              onClick={() => handleDownload(uploadState.finalVideoUrl)}
                              aria-label={t('faceSwapTab.button.deleteVideo')}
                              style={{ backgroundColor: '#fff!important', border: '2px solid #fff' }}
                            >
                              <img src={Download} alt="download" className={classes.youtubeInfoDeleteIcon} />
                            </Button>
                            <div className={classes.videoContainer} ref={videoContainerRef}>
                              <video
                                ref={finalVideoRef}
                                id="final-video"
                                src={uploadState.finalVideoUrl + '#t=0.001'}
                                crossOrigin="anonymous"
                                className={classes.responsiveVideo}
                              />
                            </div>
                          </Grid>
                          <Grid item className={classes.customControlsContainer}>
                            <div className={classes.resultPlayBarContainer}>
                              <Box display="flex" alignItems="center">
                                {isFinalVideoPlaying ? (
                                  <PauseCircleOutlineIcon
                                    className={classes.resultPlayPauseButton}
                                    onClick={handleFinalPause}
                                  />
                                ) : (
                                  <PlayCircleOutlineIcon
                                    className={classes.resultPlayPauseButton}
                                    onClick={handleFinalPlay}
                                  />
                                )}
                              </Box>
                              <div className={classes.resultSliderWrapper}>
                                <Slider
                                  value={finalSliderState.range}
                                  onChange={handleFinalSliderChange}
                                  min={0}
                                  max={100}
                                  step={0.1}
                                  aria-labelledby="final-video-slider"
                                  classes={{ root: classes.resultSliderRoot }}
                                />
                              </div>
                            </div>
                            <div className={classes.sliderTime}>
                              <span>{formatTime((finalSliderState.range / 100) * stepTwoDuration)}</span>
                              <span>/</span>
                              <span>{formatTime(stepTwoDuration)}</span>
                            </div>
                          </Grid>
                          <div className={classes.createNewButton} onClick={() => window.location.reload()}>
                            {t('faceSwapTab.button.createNew')}
                          </div>
                        </Grid>
                      ) : (
                        <>
                          {uploadState.finalVideoLoading && (
                            <Grid container className={classes.resultLoadingContainer}>
                              <CircularProgress style={{ width: '2rem', height: '2rem', color: 'white' }} />
                              <div className={classes.resultLoadingText}>
                                <p>{loadingText[0]}</p>
                                <p>{loadingText[1]}</p>
                                <p>{loadingText[2]}</p>
                                <p>{loadingText[3]}</p>
                              </div>
                            </Grid>
                          )}
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      <Box className={classes.rootContainer}>
                        {/* Video Player Section */}
                        <Grid container className={classes.allContainer}>
                          <div className={classes.previewVideoContainer}>
                            {previewLoading && (
                              <div className={classes.loadingContainer}>
                                <div className={classes.allFacesloadingText}>
                                  {t('faceSwapTab.loading.4')
                                    .split('')
                                    .map((char, index) => (
                                      <span key={index} style={{ animationDelay: `${index * 0.1}s` }}>
                                        {char}
                                      </span>
                                    ))}
                                </div>
                              </div>
                            )}
                            <Grid item id="video-container" className={classes.previewContainer}>
                              <div className={classes.tag}>{t('faceSwapTab.stepTwo.tags.preview')}</div>
                              <Button
                                className={classes.youtubeInfoDeleteIconBox}
                                onClick={handleDeleteVideo}
                                aria-label={t('faceSwapTab.button.deleteVideo')}
                              >
                                <DeleteIcon className={classes.youtubeInfoDeleteIcon} />
                              </Button>
                              <div className={classes.videoContainer} ref={videoContainerRef}>
                                <video
                                  ref={videoRef}
                                  id="uploaded-video"
                                  src={uploadState.uploadedVideoUrl + '#t=0.001'}
                                  crossOrigin="anonymous"
                                  onTimeUpdate={handleTimeUpdateStepTwo}
                                  onLoadedMetadata={handleLoadedMetadata}
                                  className={classes.responsiveVideo}
                                  preload="auto"
                                  autoplay
                                />
                                {!previewLoading && previewImageURL && (
                                  <img src={previewImageURL} alt="Preview" className={classes.previewImage} />
                                )}
                                {settingsState.isWatermarkOn && videoReady && (
                                  <img src={WaterMarkImg} alt="Watermark" className={classes.watermarkImage} />
                                )}
                              </div>
                              <div className={classes.previewButton} onClick={showPreview}>
                                {t('faceSwapTab.button.preview')}
                              </div>
                            </Grid>
                            {/* Custom Controls */}
                            <Grid item className={classes.customControlsContainer}>
                              <div className={classes.sliderWrapper}>
                                <FaceSwapTrimmingSlider
                                  value={sliderStateStepTwo.range}
                                  onChange={handleRangeChangeStepTwo}
                                  onChangeCommitted={handleSliderChangeCommitted}
                                  min={0}
                                  max={100}
                                  duration={stepOneDuration}
                                />
                              </div>
                              <div className={classes.sliderTime}>
                                {t('faceSwapTab.tooltip.videoLength')}{' '}
                                {formatTime(
                                  ((sliderStateStepTwo.range[2] - sliderStateStepTwo.range[0]) / 100) * stepOneDuration
                                )}
                                <br />
                                {t('faceSwapTab.tooltip.creditUsed')}{' '}
                                {typeof requiredCoins === 'number' && !isNaN(requiredCoins) ? requiredCoins : 0}
                              </div>
                            </Grid>
                          </div>
                          <Grid item className={classes.facesContainer}>
                            <div className={classes.tag}>{t('faceSwapTab.stepTwo.tags.detectedFaces')}</div>
                            <Grid className={classes.scrollContainer}>
                              {isProcessingFaces && (
                                <>
                                  <div />
                                  <div className={classes.allFacesloadingText}>
                                    {t('faceSwapTab.loading.1')
                                      .split('')
                                      .map((char, index) => (
                                        <span key={index} style={{ animationDelay: `${index * 0.1}s` }}>
                                          {char}
                                        </span>
                                      ))}
                                  </div>
                                </>
                              )}
                              {!isProcessingFaces && faceData.length === 0 && (
                                <div className={classes.noFacesFoundText}>{t('faceSwapTab.error.noFacesFound')}</div>
                              )}
                              {faceData.length > 0 && !isProcessingFaces && (
                                <>
                                  {faceData
                                    .filter(face => face.selected)
                                    .map((face, idx) => (
                                      <div
                                        key={idx}
                                        className={classes.faceBox}
                                        ref={el => (faceBoxRefs.current[idx] = el)}
                                      >
                                        <DeleteIcon
                                          className={classes.faceDeleteIcon}
                                          onClick={() => handleDeleteSelectedFace(face.index)}
                                        />
                                        <img
                                          src={FacesArrow}
                                          alt="arrow"
                                          className={`${classes.facesArrowOne} ${classes.facesArrowSelected}`}
                                        />
                                        <img
                                          className={`${classes.faceFromFrame} ${classes.selectedFaceSelected}`}
                                          src={face.croppedFace}
                                          alt={`Face from frame ${face.index}`}
                                        />
                                        <div
                                          className={classes.facesInputContainer}
                                          onClick={() => {
                                            setModalImageIndex(face.index);
                                            setIsFaceSelectionModalOpen(true);
                                          }}
                                        >
                                          <img
                                            src={face.selectedNewFace}
                                            alt="Selected Face"
                                            className={`${classes.selectedFace} ${classes.selectedFaceSelected}`}
                                          />
                                        </div>
                                        <img
                                          src={FacesArrow}
                                          alt="arrow"
                                          className={`${classes.facesArrowTwo} ${classes.facesArrowSelected}`}
                                        />
                                      </div>
                                    ))}

                                  {faceData.filter(face => face.selected).length > 0 && faceData.length > 0 && (
                                    <div className={classes.verticalDivider} />
                                  )}

                                  {faceData
                                    .filter(face => !face.selected)
                                    .map((face, idx) => (
                                      <div className={classes.faceBox} key={idx}>
                                        <img src={FacesArrow} alt="arrow" className={classes.facesArrowOne} />
                                        <img
                                          className={classes.faceFromFrame}
                                          src={face.croppedFace}
                                          alt={`Face from frame ${face.index}`}
                                        />
                                        <div
                                          className={classes.facesInputContainer}
                                          onClick={() => {
                                            setModalImageIndex(face.index);
                                            setIsFaceSelectionModalOpen(true);
                                          }}
                                        >
                                          <img src={FacesPlus} alt="Add Face" className={classes.facesPlus} />
                                        </div>
                                        <img src={FacesArrow} alt="arrow" className={classes.facesArrowTwo} />
                                        {/* <div className={classes.bboxLengthText}>{face.bboxLength}</div> */}
                                      </div>
                                    ))}
                                </>
                              )}
                            </Grid>
                          </Grid>
                          <Grid item className={classes.buttonContainer}>
                            <div className={classes.startContainer}>
                              <div
                                className={classes.button}
                                onClick={handlePrevButton}
                                aria-label={t('faceSwapTab.button.prev')}
                              >
                                <ArrowBackIosNewIcon style={{ fontSize: '1rem' }} />
                                <p>{t('faceSwapTab.button.prev')}</p>
                              </div>
                              <div
                                className={classes.button}
                                onClick={handleSettingsButtonClick}
                                aria-label={t('faceSwapTab.button.settings')}
                              >
                                <img src={Settings} alt="Settings" style={{ width: '1rem' }} />
                                {t('faceSwapTab.button.settings')}
                              </div>
                            </div>
                            <div className={classes.startContainer}>
                              <div className={classes.tooltipContainer}>
                                {faceSwapRemainingcount < requiredCoins ? (
                                  <div className={classes.redCoin}>
                                    {t('faceSwapTab.stepTwo.settings.poorCoin.0')}
                                    {requiredCoins - faceSwapRemainingcount}
                                    {t('faceSwapTab.stepTwo.settings.poorCoin.1')}
                                  </div>
                                ) : (
                                  <div className={classes.coin}>
                                    {t('faceSwapTab.stepTwo.settings.leftCoin.0')}
                                    {faceSwapRemainingcount}
                                    {t('faceSwapTab.stepTwo.settings.leftCoin.1')}
                                  </div>
                                )}
                                <div className={classes.coin}>
                                  {requiredCoins}
                                  {t('faceSwapTab.stepTwo.settings.requiredCoin')}
                                  <HtmlTooltip
                                    title={
                                      <div className={'globalTooltipContainer'}>
                                        <div className={'globalTooltipTextContainer'}>
                                          <div className={`globalTooltipText globalTooltipTextBullet`}>&#x2022;</div>
                                          <div className={'globalTooltipText'}>
                                            {t('faceSwapTab.tooltip.coinLogic.0')}
                                          </div>
                                        </div>
                                        <div className={'globalTooltipTextContainer'}>
                                          <div className={`globalTooltipText globalTooltipTextBullet`}>&#x2022;</div>
                                          <div className={'globalTooltipText'}>
                                            {t('faceSwapTab.tooltip.coinLogic.1')}
                                          </div>
                                        </div>
                                        <div className={'globalTooltipTextContainer'}>
                                          <div className={`globalTooltipText globalTooltipTextBullet`}>&#x2022;</div>
                                          <div className={'globalTooltipText'}>
                                            {t('faceSwapTab.tooltip.coinLogic.2')}
                                          </div>
                                        </div>
                                        <div className={'globalTooltipTextContainer'}>
                                          <div className={`globalTooltipText globalTooltipTextBullet`}>&#x2022;</div>
                                          <div className={'globalTooltipText'}>
                                            {t('faceSwapTab.tooltip.coinCal.0')}
                                            <strong>{stepTwoDuration}</strong>
                                            {t('faceSwapTab.tooltip.coinCal.1')}
                                            <strong>{Math.ceil(stepTwoDuration / 15) * 15}</strong>
                                            {t('faceSwapTab.tooltip.coinCal.2')}
                                            <strong>{faceData.filter(face => face.selected).length}</strong>
                                            {t('faceSwapTab.tooltip.coinCal.3')}
                                            {requiredCoins}
                                            {t('faceSwapTab.tooltip.coinCal.4')}
                                          </div>
                                        </div>
                                      </div>
                                    }
                                  >
                                    <img className={classes.tooltipImg} src={tooltipImg} alt="tooltip-img" />
                                  </HtmlTooltip>
                                </div>
                              </div>
                              <div
                                className={classes.button}
                                style={{ backgroundColor: '#CAFF73' }}
                                onClick={handleOpenVideoLabelModal}
                              >
                                {faceSwapInProgress
                                  ? t('faceSwapTab.button.inProgress')
                                  : t('faceSwapTab.button.start')}
                              </div>
                            </div>
                          </Grid>
                          <Grid item className={classes.prevButtonContainer}>
                            <div className={classes.startContainer}>
                              <div
                                className={classes.button}
                                onClick={handlePrevButton}
                                aria-label={t('faceSwapTab.button.prev')}
                              >
                                <ArrowBackIosNewIcon style={{ fontSize: '1rem' }} />
                                <p>{t('faceSwapTab.button.prev')}</p>
                              </div>
                            </div>
                          </Grid>
                        </Grid>

                        {/* Settings Box */}
                        <Box className={classes.settingsContainer} width="22rem" style={{ color: 'white' }}>
                          {previewLoading && <div className={classes.loadingContainer} />}
                          <FaceSwapSettings
                            t={t}
                            isSharpnessOn={settingsState.isSharpnessOn}
                            blendRatio={settingsState.blendRatio}
                            isWatermarkOn={settingsState.isWatermarkOn}
                            handleWatermarkToggle={handleWatermarkToggle}
                            coinCreditLeft={faceSwapRemainingcount}
                            requiredCoins={requiredCoins}
                            handleStart={handleOpenVideoLabelModal}
                            tierToShowOutputFormat={tierToShowOutputFormat}
                            user={user}
                            navigate={navigate}
                            onApply={handleApply}
                            duration={stepTwoDuration}
                            faceCount={faceData.filter(face => face.selected).length}
                            previewLoading={previewLoading}
                            isDisabled={isDisabled}
                          />
                        </Box>
                      </Box>
                    </>
                  )}
                </>
              )}
              {!uploadState.isVideoSplited && (
                <>
                  {uploadState.uploadedVideoUrl && videoState.duration > 0 ? (
                    <div className={classes.allContainer}>
                      <div className={classes.previewVideoContainer}>
                        <Grid item id="video-container" className={classes.previewContainer}>
                          <div className={classes.tag}>{t('faceSwapTab.stepOne.tags.sourceFile')}</div>
                          <Button
                            className={classes.youtubeInfoDeleteIconBox}
                            onClick={handleDeleteVideo}
                            aria-label={t('faceSwapTab.button.deleteVideo')}
                          >
                            <DeleteIcon className={classes.youtubeInfoDeleteIcon} />
                          </Button>
                          <div className={classes.videoContainer} ref={videoContainerRef}>
                            {uploadState.isVideoTagLoading && (
                              <div className={classes.responsiveVideo}>
                                <CircularProgress style={{ width: '2rem', height: '2rem', color: 'white' }} />
                              </div>
                            )}
                            <video
                              ref={videoRef}
                              id="uploaded-video"
                              src={uploadState.uploadedVideoUrl + '#t=0.001'}
                              crossOrigin="anonymous"
                              onTimeUpdate={handleTimeUpdate}
                              onLoadedMetadata={handleLoadedMetadata}
                              className={classes.responsiveVideo}
                              preload="auto"
                              onLoadedData={() => setUploadState(prev => ({ ...prev, isVideoTagLoading: false }))}
                              style={{ display: uploadState.isVideoTagLoading && 'none' }}
                              autoplay
                            />
                          </div>
                        </Grid>
                        {/* Custom Controls */}
                        <Grid item className={classes.customControlsContainer}>
                          <div className={classes.sliderWrapper}>
                            <FaceSwapTrimmingSlider
                              value={sliderState.range}
                              onChange={handleRangeChange}
                              onChangeCommitted={handleSliderChangeCommitted}
                              min={0}
                              max={100}
                              duration={videoState.duration}
                            />
                          </div>
                          <div className={classes.sliderTime}>
                            {t('faceSwapTab.tooltip.videoLength')}{' '}
                            {formatTime(((sliderState.range[2] - sliderState.range[0]) / 100) * videoState.duration)}
                            <br />
                            {t('faceSwapTab.tooltip.creditUsed')}{' '}
                            {typeof requiredCoins === 'number' && !isNaN(requiredCoins) ? requiredCoins : 0}
                          </div>
                        </Grid>
                      </div>
                      <Grid item className={classes.trimButtonContainer} style={{ flexDirection: 'row-reverse' }}>
                        <div className={classes.startContainer}>
                          {Math.floor(faceSwapRemainingcount / 15) >= 0 && stepOneDuration > faceSwapRemainingcount ? (
                            <div className={classes.tooltipContainer}>
                              <div className={classes.redCoin}>{t('faceSwapTab.stepOne.trimVideo.0')}</div>
                              {faceSwapRemainingcount > 0 && (
                                <div className={classes.redCoin}>
                                  {t('faceSwapTab.stepOne.trimVideo.1')}
                                  {Math.floor(faceSwapRemainingcount / 15) * 15}
                                  {t('faceSwapTab.stepOne.trimVideo.2')}
                                </div>
                              )}
                              <div
                                className={classes.coin}
                                onClick={() => navigate('/subscription')}
                                style={{ cursor: 'pointer' }}
                              >
                                <strong>{t('faceSwapTab.button.buyCredit')}</strong>
                                <ArrowForwardIosIcon className={classes.buyCreditButton} />
                              </div>
                            </div>
                          ) : (
                            <div className={classes.button} onClick={handleNextButton}>
                              <p>{t('faceSwapTab.button.next')}</p>
                              <ArrowForwardIosIcon style={{ fontSize: '1rem' }} />
                            </div>
                          )}
                        </div>
                      </Grid>
                    </div>
                  ) : (
                    <div className={classes.sourceFileContainer}>
                      <div className={classes.tag}>{t('faceSwapTab.stepOne.tags.sourceFile')}</div>
                      {uploadState.videoLoading && (
                        <div className={classes.loadingContainer}>
                          <CircularProgress style={{ width: '2rem', height: '2rem', color: 'white' }} />
                          <div className={classes.loadingAnimText}>
                            <p>{t('faceSwapTab.loading.youtubeLinkUpload.1')}</p>
                            <p>{t('faceSwapTab.loading.youtubeLinkUpload.2')}</p>
                          </div>
                        </div>
                      )}
                      <div className={classes.youtubeLinkContainer}>
                        <div className={classes.dragAndDropContainer} {...getRootProps()}>
                          <input {...getInputProps()} />
                          <img src={FileUploadImg} alt="FileUpload" className={classes.fileImg} />
                          <div className={classes.dragAndDropWrapper}>
                            <div className={classes.dragAndDropText}>
                              {t('faceSwapTab.stepOne.dragAndDropText')}
                              {t('faceSwapTab.stepOne.dragAndDropDuration')}
                            </div>
                            <div className={classes.dragAndDropText}>{t('faceSwapTab.stepOne.dragAndDropFormat')}</div>
                            <div className={classes.dragAndDropButton}>
                              {t('faceSwapTab.stepOne.dragAndDropButton')}
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <div className={classes.hrContainter}>
                        <div className={classes.hrLine} />
                        <span>or</span>
                        <div className={classes.hrLine} />
                      </div>
                      <div className={classes.youtubeLinkContainer}>
                        <OutlinedInput
                          placeholder={t('faceSwapTab.stepOne.youtubeLinkInput')}
                          onChange={e => setContent({ ...content, youtubeLink: e.target.value })}
                          value={content.youtubeLink}
                          className={classes.youtubeLinkInput}
                          onFocus={e => {
                            if (!checkValidLoginStatus(userId, dispatch)) {
                              e.target.blur();
                            }
                          }}
                          onKeyDown={e => {
                            if (e.key === 'Enter') handleYoutubeUpload();
                          }}
                        />
                        <Button
                          className={classes.searchButton}
                          disabled={!content.youtubeLink || uploadState.videoLoading}
                          onClick={handleYoutubeUpload}
                        >
                          <div className={classes.buttonText}>{t('inferenceTab.stepOne.tabs.youtube.linkbutton')}</div>
                        </Button>
                      </div> */}
                      {/* Only for testing --- from here (After testing, comment out here only) */}
                      {/* <Box display="flex" flexDirection="column" width="100%" mb={2} className={classes.distanceContainter}>
                        <Box className={classes.settingsInnerBoxSub}>
                          <div className={classes.settingsText}>{t('distance')}</div>
                          <div className={classes.settingsRatio}>{uploadState.distance}</div>
                        </Box>
                        <Slider
                          value={uploadState.distance}
                          onChange={handleDistanceChange}
                          aria-labelledby="blend-ratio-slider"
                          min={0}
                          max={1}
                          step={0.01}
                          classes={{
                            root: classes.settingsRoot,
                          }}
                        />
                      </Box>
                      <Box display="flex" flexDirection="column" width="100%" mb={2} className={classes.distanceContainter}>
                        <Box className={classes.settingsInnerBoxSub}>
                          <div className={classes.settingsText}>{t('Least Frame')}</div>
                          <input
                            className={classes.leastFrameInput}
                            placeholder={t('0')}
                            onChange={e => setUploadState({ ...uploadState, leastFrame: e.target.value })}
                            value={uploadState.leastFrame}
                          />
                        </Box>
                      </Box> */}
                      {/* Only for testing --- to here */}
                    </div>
                  )}
                </>
              )}
            </div>
          </Grid>
        </Grid>
        <Grid className={classes.footer}>
          <div
            className={classes.progressIndicator}
            style={!uploadState.isVideoSplited ? { backgroundColor: '#9F9F9F' } : {}}
          />
          <div
            className={classes.progressIndicator}
            style={uploadState.isVideoSplited && !rendering ? { backgroundColor: '#9F9F9F' } : {}}
          />
          <div className={classes.progressIndicator} style={rendering ? { backgroundColor: '#9F9F9F' } : {}} />
        </Grid>
        <Modal open={isSettingsModalOpen} onClose={() => setIsSettingsModalOpen(false)} className={classes.modal}>
          <div className={classes.modalContent}>
            {/* Settings Box Modal */}
            <Box className={classes.settingsContainerModal} width="22rem" style={{ color: 'white' }}>
              {previewLoading && (
                <div className={classes.loadingContainer}>
                  <div className={classes.allFacesloadingText}>
                    {t('faceSwapTab.loading.4')
                      .split('')
                      .map((char, index) => (
                        <span key={index} style={{ animationDelay: `${index * 0.1}s` }}>
                          {char}
                        </span>
                      ))}
                  </div>
                </div>
              )}
              <FaceSwapSettings
                t={t}
                isSharpnessOn={settingsState.isSharpnessOn}
                blendRatio={settingsState.blendRatio}
                isWatermarkOn={settingsState.isWatermarkOn}
                handleWatermarkToggle={handleWatermarkToggle}
                coinCreditLeft={faceSwapRemainingcount}
                requiredCoins={requiredCoins}
                handleStart={handleOpenVideoLabelModal}
                tierToShowOutputFormat={tierToShowOutputFormat}
                user={user}
                navigate={navigate}
                onApply={handleApply}
                duration={stepTwoDuration}
                faceCount={faceData.filter(face => face.selected).length}
                previewLoading={previewLoading}
                isDisabled={isDisabled}
              />
            </Box>
          </div>
        </Modal>
      </div>

      {/* Face Selection Modal */}
      <Dialog
        open={isFaceSelectionModalOpen}
        onClose={() => {
          setIsFaceSelectionModalOpen(false);
          setModalImageIndex(null);
          setIsImageProcessing(false);
          setCroppedFacesInImage([]);
        }}
        className={classes.faceSelectionModal}
      >
        <Grid className={classes.faceSelectionModalTitle}>{t('faceSwapTab.dialog.faceSelectionModal')}</Grid>
        <Grid className={classes.faceSelectionModalContent}>
          {isImageProcessing ? (
            <div className={classes.allFacesloadingText}>
              {t('faceSwapTab.loading.2')
                .split('')
                .map((char, index) => (
                  <span key={index} style={{ animationDelay: `${index * 0.1}s` }}>
                    {char}
                  </span>
                ))}
            </div>
          ) : (
            <>
              {croppedFacesInImage.length === 0 ? (
                <Grid style={{ margin: 'auto' }}>
                  <input
                    accept="image/*"
                    id={`image-upload-modal-${modalImageIndex}`}
                    type="file"
                    onChange={event => handleImageChange(event, modalImageIndex)}
                    className={classes.facesInput}
                    style={{ display: 'none' }}
                  />
                  <label htmlFor={`image-upload-modal-${modalImageIndex}`}>
                    <Button component="span" className={classes.faceSelectionBtn}>
                      <img src={Upload} alt="selectImg" className={classes.uploadImage} />
                      <span>{t('faceSwapTab.button.selectImage')}</span>
                    </Button>
                  </label>
                </Grid>
              ) : (
                <Grid container spacing={2}>
                  {croppedFacesInImage.map((faceImg, index) => (
                    <Grid item xs={2.5} key={index} className={classes.croppedFaceBox}>
                      <img
                        src={faceImg}
                        alt={`Cropped Face ${index + 1}`}
                        className={classes.croppedFaceImage}
                        onClick={() => {
                          setFaceData(prevFaceData =>
                            prevFaceData.map(f =>
                              f.index === modalImageIndex
                                ? {
                                    ...f,
                                    selected: true,
                                    selectedNewFace: faceImg,
                                    newFaceData: croppedFacesData[index],
                                  }
                                : f
                            )
                          );
                          setIsFaceSelectionModalOpen(false);
                          setCroppedFacesInImage([]);
                          setModalImageIndex(null);
                        }}
                      />
                    </Grid>
                  ))}
                </Grid>
              )}
            </>
          )}
        </Grid>
      </Dialog>
      <Dialog open={showUpgrade} onClose={() => setShowUpgrade(false)} className={classes.upgradeDialog}>
        <div className={classes.dialogTitle}>{t('mixingModal.dialog.title')}</div>
        <div className={classes.dialogText}>{t('faceSwapTab.dialog.upgradeText')}</div>
        <div className={classes.upgradeButton} onClick={() => navigate('/subscription')}>
          {t('mixingModal.upgradeButton.0')}
          <strong>{t('mixingModal.upgradeButton.1')}</strong>
        </div>
      </Dialog>
      <Dialog open={showCoinUpgrade} onClose={() => setShowCoinUpgrade(false)} className={classes.upgradeDialog}>
        <div className={classes.dialogTitle}>{t('faceSwapTab.modal.noRemaining.0')}</div>
        <div className={classes.dialogText}>{t('faceSwapTab.modal.noRemaining.1')}</div>
        <div className={classes.upgradeButton} onClick={() => navigate('/subscription')}>
          {t('mixingModal.upgradeButton.0')}
          <strong>{t('mixingModal.upgradeButton.1')}</strong>
        </div>
      </Dialog>
      <Dialog open={showRenderDelay} onClose={() => setShowRenderDelay(false)} className={classes.upgradeDialog}>
        <div className={classes.dialogTitle}>{t('faceSwapTab.error.pollingTimeout.0')}</div>
        <div className={classes.dialogText}>{t('faceSwapTab.error.pollingTimeout.1')}</div>
        <div className={classes.dialogText}>{t('faceSwapTab.error.pollingTimeout.2')}</div>
        <div className={classes.dialogText}>{t('faceSwapTab.error.pollingTimeout.3')}</div>
        <div className={classes.upgradeButton} onClick={() => navigate('/my-voices')}>
          {t('faceSwapTab.button.goToHistory.1')}
          <strong>{t('faceSwapTab.button.goToHistory.0')}</strong>
        </div>
      </Dialog>
      <Dialog open={showReloadDialog} onClose={handleReloadDialog} className={classes.upgradeDialog}>
        <div className={classes.dialogText}>{t('faceSwapTab.dialog.renderingError.0')}</div>
        <div className={classes.dialogText}>{t('faceSwapTab.dialog.renderingError.1')}</div>
        <div className={classes.upgradeButton} onClick={() => window.location.reload()}>
          {t('faceSwapTab.dialog.reload')}
        </div>
      </Dialog>
      <Dialog open={showPoorCoinDialog} onClose={() => setShowPoorCoinDialog(false)} className={classes.upgradeDialog}>
        <div className={classes.dialogTitle}>
          {t('faceSwapTab.stepTwo.settings.poorCoin.0')}
          {requiredCoins - faceSwapRemainingcount}
          {t('faceSwapTab.stepTwo.settings.poorCoin.1')}
        </div>
        <div className={classes.dialogText}>{t('faceSwapTab.stepTwo.settings.poorCoin.2')}</div>
        <div className={classes.dialogText}>{t('faceSwapTab.stepTwo.settings.poorCoin.3')}</div>
      </Dialog>
      <Dialog
        open={showSharpnessDialog}
        onClose={() => setShowSharpnessDialog(false)}
        className={classes.upgradeDialog}
      >
        <div className={classes.dialogTitle}>{t('faceSwapTab.dialog.sharpnessOn')}</div>
        <div className={classes.dialogText}>{t('faceSwapTab.dialog.upgradeText')}</div>
        <div className={classes.upgradeButton} onClick={() => navigate('/subscription')}>
          {t('mixingModal.upgradeButton.0')}
          <strong>{t('mixingModal.upgradeButton.1')}</strong>
        </div>
      </Dialog>
    </>
  );
}

export default FaceSwapPage;
